// src/routes/RequireAdmin.tsx
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { clearToken, getToken, isTokenValid } from "../lib/auth";

export default function RequireAdmin({
  children,
}: {
  children: React.ReactNode;
}) {
  const [checked, setChecked] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const token = getToken();
    if (!isTokenValid(token)) {
      clearToken();
      nav("/admin/login", { replace: true, state: { from: loc.pathname } });
    } else {
      setChecked(true);
    }
  }, [nav, loc.pathname]);

  if (!checked) return null;
  return <>{children}</>;
}
